// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bdJAwzaNF80dDR7oEJeVvA\\=\\={width:100%;position:relative;height:calc(100vh - 57px);align-items:stretch;display:flex}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/DeliveryDashboard.module.scss"],"names":[],"mappings":"AAAA,4BACI,UAAA,CACA,iBAAA,CACA,yBAAA,CACA,mBAAA,CACA,YAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "bdJAwzaNF80dDR7oEJeVvA=="
};
export default ___CSS_LOADER_EXPORT___;
